



























































































import qs from 'qs'
import QnaCommentsWrapper from '~/components/car/qna/QnaCommentsWrapper.vue'
import QnaAnswerForm from '~/components/car/qna/QnaAnswerForm.vue'
import QnaModalForm from '~/components/car/qna/QnaModalForm.vue'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import NoResultsFound from '~/components/car/classifieds/search/results/rows/NoResultsFound.vue'
import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import QnaQuestionHeader from '~/components/car/qna/QnaQuestionHeader.vue'
import { QNA_NS } from '~/store/modules/shared/qna/state'
import { SET_LOADING_STATE } from '~/store/modules/shared/qna/mutation-types'
import QnaPayAttention from '~/components/car/qna/QnaPayAttention.vue'
import CJsonld from '~/components/shared/configurable/seo/CJsonld.vue'
import HeadService from '~/services/HeadService'
import { faComments } from '@fortawesome/free-solid-svg-icons'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    QnaQuestionHeader,
    QnaCommentsWrapper,
    QnaAnswerForm,
    QnaModalForm,
    NoResultsFound,
    CBreadcrumbs,
    QnaPayAttention,
    CJsonld
  },
  async asyncData({ store, route }) {
    const { question } = route.params

    const questionId = question.split('-')[0]

    await store.dispatch(`${QNA_NS}/fetchQuestionDataById`, questionId)

    store.commit(`${QNA_NS}/${SET_LOADING_STATE}`, {
      loadingVar: 'fullQuestion',
      status: false
    })

    return {
      questionId
    }
  },
  data() {
    return {
      questionId: null,
      isModalVisible: false
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin',
      isAnonymous: 'isAnon'
    }),
    ...mapState(QNA_NS, {
      question: state => state.fullQuestion,
      comments: state => state.comments,
      isLoading: state => state.loading.fullQuestion
    }),
    nextUrl(): string {
      if (process.client) {
        return window.location.href
      }
      return ''
    },
    breadcrumbs() {
      const { questionCategory, questionMake, makemodel } = this.question
      const breadcrumbs = [
        { text: this.$i18n.t('questions and answers'), url: '/questions' }
      ]
      if (questionCategory?.id) {
        const categoryUrl = this.generateUrlString(
          'category',
          questionCategory.id,
          true
        )
        breadcrumbs.push({
          text: questionCategory.humanName,
          url: `/questions${categoryUrl}`
        })

        if (questionMake?.id) {
          const makeUrl = this.generateUrlString('make', questionMake.id)
          breadcrumbs.push({
            text: questionMake.name,
            url: `/questions?${categoryUrl}&${makeUrl}`
          })
          if (makemodel?.id) {
            const makeModelUrl = this.generateUrlString('model', makemodel.id)
            breadcrumbs.push({
              text: makemodel.name,
              url: `/questions${categoryUrl}&${makeUrl}&${makeModelUrl}`
            })
          }
        }
      }
      return breadcrumbs
    },
    jsonld() {
      const { question } = this
      const suggestedAnswer = []

      if (question.questionFirstComment?.comment) {
        suggestedAnswer.push({
          '@type': 'Answer',
          text: question.questionFirstComment.comment,
          dateCreated: question.questionFirstComment.added,
          upvoteCount: question.questionFirstComment?.reactions?.like || 0,
          url: `https://www.car.gr/${question.seoUrl}`,
          author: {
            '@type': 'Person',
            name: question.questionFirstComment.user.displayName
          }
        })
      }
      return {
        '@context': 'https://schema.org',
        '@type': 'QAPage',
        mainEntity: {
          '@type': 'Question',
          name: question.questionTitle,
          text: question.questionText,
          answerCount: question.questionReplies,
          upvoteCount: question.reactions?.like || 0,
          dateCreated: question.added,
          author: {
            '@type': 'Person',
            name: question.user.displayName
          },
          suggestedAnswer
        }
      }
    }
  },
  methods: {
    ...mapActions(QNA_NS, ['fetchQuestionDataById', 'createComment']),
    ...mapMutations(QNA_NS, {
      setLoading: SET_LOADING_STATE
    }),
    handleEdit() {
      this.isModalVisible = true
    },
    handleQuestionUpdate() {
      this.isModalVisible = false
    },
    async handleSubmitAnswer(text: string) {
      this.setLoading({ loadingVar: 'fullQuestion', status: true })
      try {
        await this.createComment({
          questionId: this.questionId,
          answer: text
        })
        this.$refs.qnaAnswerForm.clearText()
      } finally {
        this.setLoading({ loadingVar: 'fullQuestion', status: false })
      }
    },
    generateUrlString(
      prop: string,
      value: any,
      addQueryPrefix: boolean = false
    ) {
      return qs.stringify(
        {
          [prop]: value
        },
        { addQueryPrefix }
      )
    }
  },
  setup() {
    return {
      faComments
    }
  },
  head() {
    const headService = this.$dep(HeadService)
    const { makemodel, questionMake, questionTitle } = this.question || {}
    let title = null
    if (questionTitle) {
      title = questionTitle
    } else {
      title = this.$i18n.t('questions and answers')
    }
    if (questionMake?.name) {
      title = `${title}${questionMake.name ? ' - ' + questionMake.name : ''}`
    }
    if (makemodel?.name) {
      title = `${title} ${makemodel.name}`
    }

    return headService.createHead({
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.question.questionText
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.question.questionText
        },
        headService.createOgImageMetaItem('/nuxt-static/img/og/car-qna.jpg')
      ]
    })
  }
})
